import { atom, useAtom } from 'jotai';
import * as React from 'react';

import { Add } from '@mui/icons-material';
import { Button, IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useLocation, useNavigate } from 'react-router-dom';


export const placeholderAtom = atom(false)

function getTabFromURL(currentPath){
    switch (currentPath) {
      case "/information-hub?t=0":
        return 0
      case "/information-hub?t=1":
        return 1
      case "/information-hub?t=2":
        return 2
      default: 
        return 0
    }
}

export default function MainToolbarMaterial(props) {
  // Need to pass in as props: 
  // Cohort - Should we display presentation links tab?
  const { hasEditPermission = false } = props;
  const location = useLocation()
  const navigate = useNavigate()
  const currentPath = location.pathname + location.search;
  
  const [tabIndex, setTabIndex] = React.useState(0)
  const [needPlaceholder, setNeedPlaceholder] = useAtom(placeholderAtom)
  const theme = useTheme();
      
  let extraTab = undefined;
    // Enable presentation link for all teams
    extraTab = (
        <Tab
            value={2}
            label="Presentation Links"
        />
    );

  React.useEffect(() => {
    setTabIndex(getTabFromURL(currentPath))
  }, [currentPath])

  const handleTabChange = (e, newIndex) => {
    setTabIndex(newIndex);
    navigate('/information-hub?t=' + newIndex.toString())
  }

  const handleAddSection = () => {
    setNeedPlaceholder(true)
    // QUESTION: Best way to wait for element to load - while, setInterval, async?
    if (((typeof window !== "undefined") ? document : {}).getElementById("placeholder")) ((typeof window !== "undefined") ? document : {}).getElementById("placeholder").focus()
  }

  const tabMenu = (
      <Tabs
          className="wiki-tabs"
          sx={{
              ".MuiTab-root": {
                  textTransform: "capitalize",
                  fontSize: "1rem",
                  "&:hover": {
                    color: "#1976D2", 
                    borderBottom: "2px solid #1976D2", 
                  },
              },
              ".Mui-selected": {
                "&:hover":{
                  fontWeight: "700 !important",
                }
              },
          }}
          value={tabIndex}
          onChange={handleTabChange}
      >
          <Tab
              value={0}
              label="Cohort Information Hub"
          ></Tab>
          <Tab
              value={1}
              label="Team Information Hub"
          ></Tab>
          {extraTab}
      </Tabs>
  );


  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        background: theme?.custom?.white,
        padding: "0 20px 0 10px",
        borderBottom: "1px solid #c2c2c2",
      }}
    >
      {!props?.videoMode && <div style={{ display: "flex" }}>{tabMenu}</div>}
      {hasEditPermission ? (
        <Tooltip title="Add a new section">
          <IconButton onClick={handleAddSection}>
            {props?.videoMode ? (
              <Button
                sx={{
                  ml: 2,
                }}
                variant="contained"
                startIcon={<Add />}
              >
                Add a new section
              </Button>
            ) : (
              <Add />
            )}
          </IconButton>
        </Tooltip>
      ) : null}
    </div>
  );
}
